import { render, staticRenderFns } from "./ProductionOrderBulkActionForm.vue?vue&type=template&id=3c6f2144&"
import script from "./ProductionOrderBulkActionForm.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderBulkActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports